/* eslint-disable no-nested-ternary */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Divider, Image, Space, Stack, Text, useMantineColorScheme } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { useWistiaChannel } from '../../Service/hooks/useWistiaChannel';
import { WindowContext } from '../../Service/Context/WindowContext';
import BookitupSelect from '../../Atoms/BookitupSelect';
import { WistiaS } from '../../Service/WistiaS';
import { ThemeTitle } from '../../Atoms/ThemeText';

const ChannelNavbar = () => {
  const { channel, currentEpisode } = useWistiaChannel();
  const navigate = useNavigate();
  const { colorScheme } = useMantineColorScheme();
  const { md } = useContext(WindowContext);
  if (!channel || !currentEpisode) return null;
  const { episodes } = channel;

  return (
    <Box sx={{ maxWidth: md ? 'none' : 350, borderRadius: 5 }}>
      {!md && <Image radius="sm" src={channel.img} />}
      {md && (
        <>
          <ThemeTitle order={5}>{channel.name}</ThemeTitle>
          <Divider my="xs" />
        </>
      )}
      <BookitupSelect
        mt="md"
        value={channel.path}
        data={WistiaS.CHANNELS.map((ch) => ({ label: ch.dropdownLabel ?? ch.name, value: ch.path }))}
        onChange={(val) => val && navigate(`/academy/channels/${val}`)}
      />
      <Stack spacing="xs" mt="md" mb="xl" ml="sm">
        {episodes.map((episode, index) => {
          const isCurrent = currentEpisode === episode;
          return (
            <Text
              key={episode.id}
              weight={isCurrent ? 'bolder' : 'normal'}
              onClick={() => navigate(`/academy/channels/${channel.path}?episodeId=${episode.id}`)}
              sx={(theme) => ({
                cursor: isCurrent ? 'auto' : 'pointer',
                color: isCurrent
                  ? theme.colorScheme === 'dark'
                    ? theme.colors.blue[1]
                    : theme.colors.blue[4]
                  : theme.colorScheme === 'dark'
                  ? 'white'
                  : 'dimmed',
              })}
            >
              {`${index === 0 ? '' : `${index}.`} ${episode.title}`}
            </Text>
          );
        })}
      </Stack>
      {md && <Space h={50} />}
    </Box>
  );
};

export default ChannelNavbar;
